import { Divider, Empty } from 'antd'
import { createStyles } from 'antd-style'

import { NavigateButton } from '@eastcoal/common/components/Button/NavigateButton'

import { ThrottleButton } from '../Button/ThrottleButton'

import { DataEmptyProps } from './interface'

const useStyles = createStyles(({ token }) => ({
  dataEmtpy: {
    margin: 0
  }
}))

/**
 * 数据为空时的提示
 */
export const DataEmpty = ({
  className,
  style,
  message = '暂无数据',
  icon = true,
  to,
  loading,
  reload
}: DataEmptyProps) => {
  const { cx, styles } = useStyles()

  const content = (
    <div>
      <ThrottleButton
        loading={loading}
        title='点击刷新'
        type='text'
        onClick={reload}
      >
        {message}
      </ThrottleButton>
      {to && (
        <>
          <Divider orientation='vertical' />
          <NavigateButton to={to}>点击前往配置</NavigateButton>
        </>
      )}
    </div>
  )

  const rootCls = cx(styles.dataEmtpy, className)

  return icon ? (
    <Empty
      className={rootCls}
      description={content}
      image={Empty.PRESENTED_IMAGE_SIMPLE}
      style={style}
    />
  ) : (
    <div className={rootCls} style={style}>
      {content}
    </div>
  )
}
